/**
 * @desc 列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderRelevanceRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/oms/systemOrderRelevance/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
